__turbopack_context__.v({
  "animatedPath": "Logo-module__zh8txq__animatedPath",
  "letter1": "Logo-module__zh8txq__letter1",
  "letter2": "Logo-module__zh8txq__letter2",
  "letter3": "Logo-module__zh8txq__letter3",
  "letter4": "Logo-module__zh8txq__letter4",
  "letter5": "Logo-module__zh8txq__letter5",
  "letter6": "Logo-module__zh8txq__letter6",
  "logoColorCycle": "Logo-module__zh8txq__logoColorCycle",
});
